export interface ContactFormConfig {
  name?: string;
  jobTitle?: string;
  email?: string;
  phoneNumber?: string;
  company?: string;
  annualRevenue?: string;
  customers?: string;
}

export const CapitalAmountOptions = [
  '$100k or less',
  '$100k to $250k',
  '$250k to $500k',
  '$500k to $750k',
  '$750k to $1M',
  '$1M or more',
] as const;

type CapitalAmountType = (typeof CapitalAmountOptions)[number];

export const ProductsOptions = [
  'Asset-Based Lending',
  'Receivables Finance',
  'Invoice Financing',
  'Term Loans',
  'Purchase Order Financing',
  'Production Financing',
] as const;

export type ProductsType = (typeof ProductsOptions)[number];

export const PrioritiesOptions = ['Payroll', 'Production', 'Stabilize cash flow', 'Working capital', 'Other'] as const;

export type PrioritiesType = (typeof PrioritiesOptions)[number];

export interface GoalsFormConfig {
  capitalAmount?: CapitalAmountType;
  products: ProductsType[];
  priorities: (PrioritiesType | string)[]; // "Other" prompts free text entry
  existingFinancing?: boolean;
  successfulFundingExperience?: string;
  favoriteMeal?: string;
}

export interface LendingFormConfig {
  contact: ContactFormConfig;
  goals: GoalsFormConfig;
}
